import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/finance-plan", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/finance-plan/csv", params);
};

const get = id => {
  return restApi.get(`/api/finance-plan/${id}`);
};

const upsert = data => {
  return restApi.post("/api/finance-plan/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/finance-plan/${ids}`);
};

const financePlanService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default financePlanService;